module.exports = __webpack_public_path__ + "assets/c20e9e648ce9d4b3c1a4a765e50c875b.jpg";